import React, { Fragment } from 'react';
import { Button, Form, Input, Row, Col, Card } from 'antd';
import CountDown from 'components/ant-design-pro/CountDown';
import { connect } from 'dva';
import { formItemLayout } from 'utils/utils.js';
import { mobileRegExp } from 'utils/regexp-utils.js';
import classnames from 'classnames';
import BankAccountLinkageFragment from 'components_business/BankAccountLinkageFragment/Index.js';
import styles from './Index.less';

const FormItem = Form.Item;

@connect(({ merchantBusinessAddBankCard, loading }) => ({
  showCountDown: merchantBusinessAddBankCard.showCountDown,
  loading: loading.effects['merchantBusinessAddBankCard/fetchCardInfo'] !== false,
  loadingBankBranch: loading.effects['merchantBusinessAddBankCard/fetchBankBranch'],
  loadingSendCode: loading.effects['merchantBusinessAddBankCard/sendCode'],
  submitting: loading.effects['merchantBusinessAddBankCard/submit'],
  sendCode: loading.effects['merchantBusinessAddBankCard/sendCode'],
  cardInfo: merchantBusinessAddBankCard.cardInfo,
  bankBranchInfo: merchantBusinessAddBankCard.bankBranchInfo,
}))
@Form.create()
export default class AddBankCardForm extends React.Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderContent = this.renderContent.bind(this);
    this.handleSendCode = this.handleSendCode.bind(this);
    this.renderSendCode = this.renderSendCode.bind(this);
    this.renderSmsCode = this.renderSmsCode.bind(this);
  }

  componentDidMount() {
    this.props.dispatch({ type: 'merchantBusinessAddBankCard/fetchCardInfo' });
  }

  handleSendCode() {
    const { form, dispatch, showCountDown, type } = this.props;

    if (showCountDown) {
      return;
    }

    if (type === 'add') {
      form.validateFields(['name', 'bankNo', 'bankName', 'bankBranch', 'mobile'], (err, values) => {
        if (!err) {
          const payload = {
            name: values.name,
            bankNo: values.bankNo,
            bankName: values.bankName,
            bankBranchName: values.bankBranch.label,
            bankCode: values.bankBranch.key,
            mobile: values.mobile,
          };

          dispatch({
            type: 'merchantBusinessAddBankCard/sendCodeAdd',
            payload,
          });
        }
      });
    } else if (type === 'edit') {
      form.validateFields(
        ['name', 'oldBankNo', 'bankNo', 'bankName', 'bankBranch', 'mobile'],
        (err, values) => {
          if (!err) {
            const payload = {
              name: values.name,
              bankNo: values.bankNo,
              bankName: values.bankName,
              bankBranchName: values.bankBranch.label,
              bankCode: values.bankBranch.key,
              mobile: values.mobile,
              oldBankNo: values.oldBankNo,
            };

            dispatch({
              type: 'merchantBusinessAddBankCard/sendCodeUpdate',
              payload,
            });
          }
        }
      );
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    const { saveSuccessCallback, form, dispatch, type, cardInfo } = this.props;

    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const payload = {
          bankNo: values.bankNo,
          bankName: values.bankName,
          bankBranchName: values.bankBranch.label,
          bankCode: values.bankBranch.key,
          mobile: values.mobile,
        };

        let effectName = 'merchantBusinessAddBankCard/submit';
        if (cardInfo.type === 0) {
          payload.smsCode = values.smsCode;
        } else {
          effectName = 'merchantBusinessAddBankCard/sendCodeAdd';
        }

        if (type === 'edit') {
          payload.oldBankNo = values.oldBankNo;
        }

        dispatch({
          type: effectName,
          payload,
        }).then(() => {
          if (saveSuccessCallback) {
            saveSuccessCallback();
          }
        });
      }
    });
  }

  renderSendCode() {
    const { loadingSendCode, showCountDown } = this.props;

    if (showCountDown) {
      const targetTime = new Date().getTime() + 1000 * 120;
      return (
        <Button type="primary" disabled>
          <CountDown
            target={targetTime}
            onEnd={() => {
              this.props.dispatch({ type: 'merchantBusinessAddBankCard/toggleCountDown' });
            }}
            format={time => `${Math.floor(time / 1000)}s`}
          />
        </Button>
      );
    }

    return (
      <Button type="primary" onClick={this.handleSendCode} loading={loadingSendCode}>
        获取
      </Button>
    );
  }

  renderSmsCode(newFormItemLayout, getFieldDecorator) {
    const { cardInfo, sendCode } = this.props;

    if (cardInfo.type === 0) {
      return (
        <Fragment>
          <FormItem {...newFormItemLayout} label="验证码" className="sms-code">
            {getFieldDecorator('smsCode', {
              rules: [{ required: true, message: '请输入验证码' }],
            })(
              <Row>
                <Col span={18}>
                  <Input placeholder="请输入" />
                </Col>
                <Col offset={2} span={4}>
                  {this.renderSendCode()}
                </Col>
              </Row>
            )}
          </FormItem>

          <Row
            className={classnames({
              'mobile-code-tips': true,
              hide: sendCode === undefined,
            })}
          >
            <Col>*请在120s内输入验证码并确认，若未收到验证码，请检查输入内容是否正确</Col>
          </Row>
        </Fragment>
      );
    }
  }

  renderContent() {
    const { submitting, cardInfo, loading, extraActions, itemLayout = {}, type } = this.props;

    let nameLabel = '开户名';
    let idNoLabel = '身份证号';

    if (cardInfo.type) {
      nameLabel = '公司名称';
      idNoLabel = '统一社会信用代码';
    }

    if (loading) {
      return null;
    }

    const newFormItemLayout = Object.assign({}, formItemLayout, itemLayout);

    const { form: { getFieldDecorator }, form } = this.props;

    return (
      <Form onSubmit={this.handleSubmit} className={styles.root}>
        <FormItem {...newFormItemLayout} label={nameLabel}>
          {getFieldDecorator('name', {
            initialValue: cardInfo.name,
            rules: [{ required: true, message: `${nameLabel}为空` }],
          })(<Input placeholder="请输入" disabled />)}
        </FormItem>

        {type === 'edit' && (
          <FormItem {...newFormItemLayout} label="解绑卡号">
            {getFieldDecorator('oldBankNo', {
              rules: [{ required: true, message: '请输入解绑卡号' }],
            })(<Input placeholder="请输入" />)}
          </FormItem>
        )}

        <BankAccountLinkageFragment newFormItemLayout={newFormItemLayout} form={form} />

        <FormItem {...newFormItemLayout} label={idNoLabel}>
          {getFieldDecorator('idNo', {
            initialValue: cardInfo.idNo,
            rules: [{ required: true, message: `${idNoLabel}为空` }],
          })(<Input placeholder="请输入" disabled />)}
        </FormItem>

        <FormItem {...newFormItemLayout} label="预留手机号">
          {getFieldDecorator('mobile', {
            rules: [
              { required: true, message: '请输入预留手机号' },
              {
                pattern: mobileRegExp,
                message: '请输入正确的手机号',
              },
            ],
          })(<Input placeholder="请输入" />)}
        </FormItem>

        {this.renderSmsCode(newFormItemLayout, getFieldDecorator)}

        <FormItem className="operation-button-wrap">
          <Button type="primary" htmlType="submit" loading={submitting}>
            {cardInfo.type ? '下一步' : '保存'}
          </Button>
          {extraActions}
        </FormItem>
      </Form>
    );
  }

  render() {
    const { loading } = this.props;

    return (
      <Card bordered={false} loading={loading} className={styles.card}>
        {this.renderContent()}
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Merchant/Business/components/AddBankCardForm/Index.js